import { defineGameCard, onAppear } from '../authoring/index.js';
export const BlackKnightCard = defineGameCard({
    id: 'black_knight',
    gameplay: { type: 'UNIT', cost: 6, baseStats: { attack: 6, health: 7 } },
    presentation: {
        name: 'Чёрный рыцарь',
        description: 'При раскрытии нанесите 2 урона случайному уже раскрытому вражескому бойцу.',
        glyph: {
            colors: ['#10213A', '#2D3134', '#5C6166', '#202224', '#131415'],
            rows: [
                '....................',
                '.......111111.......',
                '......12233241......',
                '.....1222332241.....',
                '....11222332241.....',
                '....122223322241....',
                '...1122223322241....',
                '...12233333333241...',
                '...12555555555541...',
                '...12555555555541...',
                '...12233355333241...',
                '...12222255422241...',
                '...12222255422241...',
                '...12222255422441...',
                '...15222255424451...',
                '..1155222554445541..',
                '..1225522554455421..',
                '...11525555554511...',
                '.....1222222441.....',
                '......11111111......',
            ],
        },
    },
    role: 'playable',
    abilities: [onAppear((ctx) => {
            if (ctx.self === undefined)
                return;
            const opponent = ctx.q.opponentOf(ctx.self.controllerId);
            const candidates = ctx.q.unitsOf(opponent.id)
                // FIELD cards are materialized as a batch before individual appearances.
                // Only a card whose appearance already completed is face up and targetable.
                .filter((unit) => ctx.q.cardType(unit.id) === 'UNIT' && ctx.q.hasCompletedAppearance(unit.id));
            if (candidates.length === 0)
                return;
            ctx.ops.dealDamage({ kind: 'unit', instanceId: ctx.rng.pick(candidates).id }, 2);
        }, { cause: 'played' })],
});
//# sourceMappingURL=black_knight.js.map